import { Box, Link, Table, Tbody, Td, Tr } from '@chakra-ui/react';

import { Customer, getFullName } from '../../gql/customerGql';
import { DealContact } from '../../gql/dealContactGql';
import { Deal, DealStateEnum, DealStateLabelMap } from '../../gql/dealGql';
import { Deal as GeneratedDeal, Maybe } from '../../gql/generated/graphql';

import Modal from '../shared/Modal';

const getDriverName = (deal: Deal | GeneratedDeal) => {
  let driver;
  if (deal.customer) {
    driver = deal.customer;
  } else if (deal.cobuyer) {
    driver = deal.cobuyer;
  } else if (deal.contact) {
    driver = deal.contact;
  }

  if (!driver) {
    return null;
  }

  return getFullName(driver as Customer | DealContact);
};

type MultipleDealsModalProps = {
  deals: Maybe<Deal | GeneratedDeal>[];
  isOpen: boolean;
  onClose: () => void;
  openTextWidget?: boolean;
  handleOpenTextWidget?: (deal: Deal | GeneratedDeal) => void;
};

const MultipleDealsModal = ({
  deals,
  isOpen,
  onClose,
  openTextWidget = false,
  handleOpenTextWidget,
}: MultipleDealsModalProps) => (
  <Modal title="Select Deal" isCentered isOpen={isOpen} onClose={onClose} size="3xl">
    <Box p={5}>
      This number is associated with multiple deals. Please choose which deal you'd like to view.
    </Box>
    <Table>
      <Tbody>
        {deals.map((deal) => {
          if (!deal) {
            return null;
          }

          const driverName = deal ? getDriverName(deal) : '';

          return (
            <Tr key={deal.id}>
              <Td>
                <Link
                  color="blue.600"
                  fontWeight="bold"
                  textDecoration="underline"
                  href={`/deals/${deal.id}`}
                  onClick={(e) => {
                    if (openTextWidget && handleOpenTextWidget) {
                      e.preventDefault();

                      handleOpenTextWidget(deal);
                    }
                  }}
                >
                  {deal.id}
                </Link>
              </Td>
              <Td fontWeight="bold" px={3} textTransform="capitalize">
                {driverName}
              </Td>
              <Td px={3}>{`${deal?.car?.year} ${deal?.car?.make} ${deal?.car?.model}`}</Td>
              <Td>{deal?.state && DealStateLabelMap[deal?.state as DealStateEnum]}</Td>
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  </Modal>
);

export default MultipleDealsModal;
